import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation }    from 'react-router-dom';

import './style.scss';

import Preloader     from '../../components/containers/preloader';
import Meta           from '../../components/meta';
import PageHeader    from '../../components/pageHeader';
import { useCommon } from '../../providers/common';

import developerFlatPng  from '../../assets/images/developer_flat.png';
import developerFlatPdf  from '../../assets/tmp/developer_flat.pdf';
import developerHousePng from '../../assets/images/developer_house.png';
import developerHousePdf from '../../assets/tmp/developer_house.pdf';

const Developer = function() {
  const {
          pages,
          loading,
        }            = useCommon();
  const { pathname } = useLocation();
  const { t }        = useTranslation();

  const page = useMemo(() => pages.find((page) => `/${page.urlKey}` === pathname), [pages, pathname]);

  React.useEffect(() => {
    if (!isSSR()) {
      scrollTo({
        top:  0,
        left: 0,
      });
    }
  }, []);

  return (
    <>
      <div className={'page-content'}>
        <Meta {...page?.meta} />
        <PageHeader>{page.label}</PageHeader>
        <main className={page.template}>
          <section>
            <p>{t('developer.description')}</p>
            <div className={'developer-list'}>
              <div className={'developer-item'}>
                <picture>
                  <img
                    src={developerFlatPng}
                    alt={'developer_flat'}
                  />
                </picture>
                <a
                  className={'btn fill'}
                  href={developerFlatPdf}
                  rel={'nofollow'}
                  target={'_blank'}
                >{t('developer.download')}</a>
              </div>
              <div className={'developer-item'}>
                <picture>
                  <img
                    src={developerHousePng}
                    alt={'developer_house'}
                  />
                </picture>
                <a
                  className={'btn fill'}
                  href={developerHousePdf}
                  rel={'nofollow'}
                  target={'_blank'}
                >{t('developer.download')}</a>
              </div>
            </div>
          </section>
          <section
            className={'developer-contacts'}
            dangerouslySetInnerHTML={{ __html: t('developer.contacts') }}
          />
        </main>
      </div>
      {loading && (
        <Preloader />
      )}
    </>
  );
};

export default Developer;